import React, { lazy } from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
import { CTAButton } from './CTAButton';
export function BonusSection() {
  const fadeIn = useFadeIn();
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const bonuses = [{
    id: 1,
    emoji: '🗝️',
    title: 'BONO 1 — Juegos para descubrir lo que siente',
    desc: 'Conversaciones profundas disfrazadas de juego. Abrís mundos sin que parezca una charla seria.',
    image: 'https://cdn.magicpatterns.com/uploads/odG8KduDRrvn4roiuPyHTQ/BONO_3.png',
    price: '€5'
  }, {
    id: 2,
    emoji: '💌',
    title: 'BONO 2 — 30 cosas que quiero que nunca olvides',
    desc: 'Frases y actividades para dejar una huella emocional imborrable en tus hijos.',
    image: 'https://cdn.magicpatterns.com/uploads/skodB8V7Uu5t5qN4pYh45G/BONO_1.png',
    price: '€5'
  }, {
    id: 3,
    emoji: '🎉',
    title: 'BONO 3 — 52 Planes Mágicos',
    desc: 'Una idea nueva cada semana del año. Nunca más un fin de semana vacío.',
    image: 'https://cdn.magicpatterns.com/uploads/4gN5gQQqAHrk4h1ejTW1T8/BONO_2.png',
    price: '€5'
  }, {
    id: 4,
    emoji: '👵',
    title: 'BONO 4 — Abuelita, cuéntame tu historia',
    desc: 'Para que los abuelos compartan sus recuerdos y sabiduría con toda la familia.',
    image: 'https://cdn.magicpatterns.com/uploads/imQe53N76XbcTTBMTUGdfx/BONO_4.png',
    price: '€5'
  }, {
    id: 5,
    emoji: '👴',
    title: 'BONO 5 — Abuelito, cuéntame tu historia',
    desc: 'Para que los abuelos compartan sus vivencias y enseñanzas antes de que sea tarde.',
    image: 'https://cdn.magicpatterns.com/uploads/vCqm6gwmTpMai74k32Y2Dv/BONO_5.webp',
    price: '€5'
  }, {
    id: 6,
    emoji: '👩',
    title: 'BONO 6 — Mamá, cuéntame tu historia',
    desc: 'Un espacio para que mamá comparta su vida, sus sueños y sus aprendizajes.',
    image: 'https://cdn.magicpatterns.com/uploads/kwLs8BsgkHj4EqXU9YQZX9/BONO_6.webp',
    price: '€5'
  }, {
    id: 7,
    emoji: '👨',
    title: 'BONO 7 — Papá, cuéntame tu historia',
    desc: 'Un espacio para que papá deje su historia escrita para siempre.',
    image: 'https://cdn.magicpatterns.com/uploads/uT6uLig1hSZGzYMWq4GB2e/BONO_7.webp',
    price: '€5'
  }];
  return <section className="py-10 md:py-16 px-4 bg-gray-900 text-white border-y-8 border-yellow-400" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-29">
          <div className="text-center mb-8 md:mb-12" data-id="element-30">
            <h2 className="text-2xl md:text-5xl font-black text-yellow-400 mb-3 md:mb-4" data-id="element-31">
              🎁 7 BONOS EXCLUSIVOS
            </h2>
            <p className="text-base md:text-2xl font-bold text-white" data-id="element-32">
              SOLO POR ACCEDER HOY
            </p>
          </div>

          <div className="space-y-4 md:space-y-8 mb-8 md:mb-12" data-id="element-33">
            {bonuses.map(bonus => <div key={bonus.id} className="bg-white text-gray-900 rounded-2xl p-4 md:p-6 shadow-lg md:shadow-2xl relative border-2 md:border-4 border-yellow-400 overflow-hidden" style={{
            contentVisibility: 'auto',
            containIntrinsicSize: '0 400px'
          }} data-id="element-34">
                <div className="absolute top-3 md:top-4 right-[-40px] md:right-[-35px] bg-red-600 text-white font-black py-1 px-8 md:px-10 transform rotate-45 shadow-md text-[10px] md:text-base" data-id="element-35">
                  GRATIS
                </div>

                <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6" data-id="element-36">
                  {bonus.image ? <button onClick={scrollToPricing} className="w-full md:w-1/3 flex-shrink-0 cursor-pointer md:hover:scale-105 md:transition-transform" data-id="element-37">
                      <img src={bonus.image} alt={bonus.title} className="w-[160px] h-[160px] md:w-[250px] md:h-[250px] object-contain mx-auto drop-shadow-xl" loading="lazy" decoding="async" width={1080} height={1080} data-id="element-38" />
                    </button> : <div className="w-full md:w-1/3 flex-shrink-0 flex items-center justify-center" data-id="element-39">
                      <div className="w-[120px] h-[120px] md:w-[180px] md:h-[180px] bg-yellow-50 border-2 border-yellow-300 rounded-2xl flex items-center justify-center" data-id="element-40">
                        <span className="text-5xl md:text-7xl" data-id="element-41">
                          {bonus.emoji}
                        </span>
                      </div>
                    </div>}

                  <div className="text-center md:text-left flex-1" data-id="element-42">
                    <div className="inline-block bg-yellow-400 text-black font-black px-3 py-1 rounded-md mb-2 md:mb-3 text-xs md:text-sm uppercase tracking-wider" data-id="element-43">
                      {String(bonus.id).padStart(2, '0')}
                    </div>
                    <h3 className="text-lg md:text-2xl font-black text-gray-900 mb-2 md:mb-3 leading-tight" data-id="element-44">
                      {bonus.title}
                    </h3>
                    <p className="text-sm md:text-lg text-gray-600 mb-3 md:mb-4 font-medium" data-id="element-45">
                      {bonus.desc}
                    </p>
                    <p className="inline-block bg-gray-100 px-3 md:px-4 py-1.5 md:py-2 rounded-lg text-xs md:text-sm font-bold text-gray-500 border border-gray-200" data-id="element-46">
                      <span className="line-through text-red-500" data-id="element-47">
                        {bonus.price}
                      </span>{' '}
                      <span className="text-green-600 ml-1 font-black" data-id="element-48">
                        GRATIS
                      </span>
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center mb-8" data-id="element-49">
            <p className="text-lg md:text-2xl font-bold text-yellow-400" data-id="element-50">
              Valor total bonos €35 →{' '}
              <span className="text-white" data-id="element-51">
                Incluidos GRATIS con tu Pack hoy
              </span>
            </p>
          </div>

          <div className="max-w-md mx-auto" data-id="element-52">
            <CTAButton text="👉 QUIERO MI PACK CON LOS 7 BONOS" size="sm" data-id="element-53" />
          </div>
        </div>
      </div>
    </section>;
}